export default __webpack_public_path__ + "static/media/greenhouseHP.090510ee.png";